import { totalPriceMapper } from '../create/config';
import { colSize } from '../../../../data/enums/Styles';
import { SRN } from '../../../../data/enums/Route';
import { breadCrumbConfig } from '../config';
import { imageSliderListFormatter } from '../../../common/HelperFunctions';

const breadCrumb = [
  ...breadCrumbConfig,
  {
    id: 1,
    title: 'SRN',
    path: `/${SRN}`,
    active: true,
  },
];

const summaryDetailsMapper = (data) => {
  const summaryList = [
    {
      title: 'SRN Invoice Number',
      value: data.SRNInvoiceNumber || '',
      colSpace: colSize.qtr,
    },
    {
      title: 'Sales Invoice Number',
      value: data.invoiceNumber || '',
      colSpace: colSize.qtr,
    },
    {
      title: 'Outlet',
      value: data.RetailOutlet ? data.RetailOutlet.title : '',
      colSpace: colSize.l,
    },
    {
      title: '',
      value: '',
      colSpace: colSize.qtr,
    },
    {
      title: 'Ledger',
      value: data.Customer ? data.Customer.name || '' : '',
      colSpace: colSize.tri,
    },
    {
      title: 'Bill Name',
      value: data.customerName ? data.customerName : '',
      colSpace: colSize.tri,
    },
    {
      title: 'Address',
      value: data.Customer ? data.Customer.address || '' : '',
      colSpace: colSize.tri,
    },
    {
      title: 'PAN',
      value: data.Customer ? data.Customer.panNumber || '' : '',
      colSpace: colSize.tri,
    },
    {
      title: 'Remarks',
      value: data.reason || '',
      colSpace: colSize.l,
    },
    {
      title: 'SRN Date',
      value: data.srnDate ? data.srnDate : '',
      colSpace: colSize.qtr,
    },
  ];
  return summaryList;
};

const lineMapper = (lines) =>
  lines.map((item) => {
    /* item.images = [{
    thumbnail: 'https://storage.googleapis.com/rmap_images/149/149_Yuna Cold Store_1_1461062344.jpeg',
    w: 1200,
    h: 900,
    title: '2016-04-19',
    src: 'https://storage.googleapis.com/rmap_images/149/149_Yuna Cold Store_1_1461062344.jpeg',
  },
  {
    src: 'https://storage.googleapis.com/rmap_images/149/149_Yuna Cold Store_1_1463991987.jpeg',
    thumbnail: 'https://storage.googleapis.com/rmap_images/149/149_Yuna Cold Store_1_1463991987.jpeg',
    w: 1200,
    h: 900,
    title: '2016-05-23',
  },
  {
    src: 'https://storage.googleapis.com/rmap_images/149/149_Yuna Cold Store_1_1473078477.jpeg',
    thumbnail: 'https://storage.googleapis.com/rmap_images/149/149_Yuna Cold Store_1_1473078477.jpeg',
    w: 1200,
    h: 900,
    title: '2016-09-05',
  },
  {
    thumbnail: `${process.env.PUBLIC_URL}/image/icons/ic_close.svg`,
    w: 100,
    h: 100,
    title: '2016-04-19',
    src: `${process.env.PUBLIC_URL}/image/icons/ic_close.svg`,
  },
  ]; */
    item.images = imageSliderListFormatter(item.images || []);
    return item;
  });

const dataMapper = (data = {}) => ({
  srnInvoiceNumber: data.SRNInvoiceNumber || '',
  summary: summaryDetailsMapper(data),
  lines: data.SRNDetails || [],
  // lines: data.SRNDetails ? lineMapper(data.SRNDetails) : [], /** for test purpose only **/
  srnAmount: data.srnAmount || totalPriceMapper({}),
  Distributor: data.Distributor || { serviceUsed: {} },
  paymentMode: data.paymentMode,
  customerName: data.customerName,
});

export { dataMapper as detailDataMapper, breadCrumb };
